import { useEffect, useState } from "react"

import { useCheckList } from "./CheckListContext"

import AddOption from "./AddOption"
import ButtonBar from "./ButtonBar"
import DeleteButton from "./DeleteButton"
import ReadOnlyField from "./ReadOnlyField"
import SimpleCheckListItem from "./SimpleCheckListItem"
import TextInput from "./TextInput"

const CheckListItemWithOptions = ({ctx, childType, asTable=false}) => {
    const [rec, setRec] = useState(null)
    const { getRec } = useCheckList()

    useEffect(
        () => {
            !!ctx && setRec(getRec(ctx))
        }, [ctx, getRec]
    )

    if (!rec && asTable) {
        return (<tr><td colSpan="7">Loading...</td></tr>)
    } else if (!rec) {
        return (<div>loading...</div>)
    }

    if (asTable) {
        return (
            <>
            <tr>
                <td><ButtonBar rec={rec} /></td>
                <td>{rec.type}  </td>
                <td><ReadOnlyField rec={rec} fld="id" size="18" /></td>
                <td><TextInput rec={rec} fld="label" size="45" unique={true} /></td>
                <td><TextInput rec={rec} fld="abbrLabel" size="20" /></td>
                <td><TextInput rec={rec} fld="feedback" size="20"/></td>
                <td><DeleteButton rec={rec} /></td>
            </tr>
            <tr>
                <td></td>
                <td colSpan="6">
                    <fieldset className="top-level">
                        <legend>Options</legend>
                    {!ctx.options
                     ?<p>There aren't currently any options</p>
                     : <table>
                         <thead>
                             <tr>
                                <th></th>
                                <th>Type</th>
                                <th>ID</th>
                                <th>Label</th>
                                <th>Abbr. Label</th>
                                <th></th>
                            </tr>
                         </thead>
                         <tbody>
                             {ctx.options.map((opt, i) =>
                                 <SimpleCheckListItem
                                    key={ opt.id }
                                    ctx={ opt }
                                    hasPromptID={true}
                                    hasFeedback={false}
                                    asTable={true}
                                 />
                             )}
                         </tbody>
                     </table>
                    }
                    <AddOption
                        index={rec._ctx.lastIndex + 1}
                        phase={rec.phase}
                        subPhase={rec.subPhase}
                        childType={childType}
                        parentID={rec.id}
                    />
                </fieldset>
            </td>
            </tr>
            </>
        )
    }
    return (
        <div className="item-with-options">
            <ButtonBar rec={rec} />
            <span>
                <b>{rec.type}</b>
                <ReadOnlyField rec={rec} fld="id" label="ID" />
                <TextInput rec={rec} fld="label" label="Label" unique={true} />
                <TextInput rec={rec} fld="abbrLabel" label="Abbr. Label" />
                <DeleteButton rec={rec} />
            </span>
            <fieldset>
                <legend>Options</legend>
                {!!ctx.options
                 ? ctx.options.map((opt, i) =>
                        <SimpleCheckListItem
                            key={opt.id}
                            ctx={opt}
                            hasPromptID={true}
                        />
                    )
                  : <p>There currently aren't any options</p>
                }
                <AddOption
                    index={rec._ctx.lastIndex + 1}
                    phase={rec.phase}
                    subPhase={rec.subPhase}
                    childType={childType}
                    parentID={rec.id}
                />
            </fieldset>
        </div>
    )

}
// index = { ctx.options[ctx.options.length - 1].index }

export default CheckListItemWithOptions